import React, { useEffect, useCallback } from 'react';
import { useError } from '../../contexts/ErrorContext';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Button, Box } from '@mui/material';

const ErrorDisplay = () => {
    const { error, hideError } = useError();
    const navigate = useNavigate();

    const handleClose = useCallback(() => {
        hideError();
        navigate(-1); // Go back to the previous screen
    }, [hideError, navigate]);

    useEffect(() => {
        return () => {
            hideError();
        };
    }, [hideError]);

    if (!error) return null;

    return (
        <div className="error-overlay">
            <Container maxWidth="sm">
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    height="100vh"
                    bgcolor="background.paper"
                    p={3}
                    borderRadius={2}
                    boxShadow={3}
                >
                    <Typography variant="h4" gutterBottom>
                        Error
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        {error}
                    </Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                </Box>
            </Container>
        </div>
    );
};

export default ErrorDisplay;
